import { isObject } from './isObject.js';

export const toSafeObject = (value, fallback = {}) => {
  if (!isObject(value)) {
    return fallback;
  }

  return value;
};
